const photoColors = ['#334760', '#ff414d', '#fecc2e', '#25d5d8', '#2980d0']

export const photoBgColor = (id) => {
  return photoColors[
    id
      ? id % photoColors.length
      : Math.floor(Math.random() * photoColors.length)
  ]
}
